export default __webpack_public_path__ + "static/Romie-Black-32aa130159f14aaf663e12c3e0cb0774.woff2";